/*
 * Copyright (c) 2023. Bolmate B.V.
 */

import {ErrorType, ResponseData, showDialog} from '@dvrd/dvr-controls';
import React, {ForwardedRef, forwardRef, useContext, useImperativeHandle, useState} from 'react';
import {ActivateHandle} from "../../../../util/interfaces";
import {applyCoupon} from "../../../../util/requestSender";
import {createErrorMessage} from "../../../../util/utils";
import SubscriptionCoupon from "./subscriptionCoupon";
import {onShowConfirmSnackbar} from "../../../../util/renderUtil";
import {AppContext} from "../../../misc/appContext";

interface Props {
    onSuccess: VoidFunction;
}

function SubscriptionCouponController(props: Props, ref: ForwardedRef<ActivateHandle>) {
    const {account} = useContext(AppContext).accountContext;
    const {onSuccess} = props;
    const [active, setActive] = useState(false);
    const [coupon, setCoupon] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ErrorType>(null);

    function onActivate() {
        setActive(true);
    }

    function onClose() {
        setActive(false);
        setCoupon('');
        setLoading(false);
        setError(null);
    }

    function onChangeCoupon(value: string) {
        setCoupon(value);
    }

    function onSubmit() {
        if (!account) return;
        setError(null);
        setLoading(true);
        applyCoupon({
            data: {account_id: account.id, coupon}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    onSuccess();
                    onClose();
                    onShowConfirmSnackbar('De coupon is toegepast op jouw abonnement');
                } else if (data.message) setError(data.message);
                else
                    showDialog(createErrorMessage('Het toepassen van de coupon is mislukt.'), 'Toepassen mislukt');
            }
        });
    }

    useImperativeHandle(ref, () => ({activate: onActivate}));

    return (
        <SubscriptionCoupon onClose={onClose} onChangeCoupon={onChangeCoupon} onSubmit={onSubmit} active={active}
                            loading={loading} error={error} coupon={coupon}/>
    );
}

export default forwardRef<ActivateHandle, Props>(SubscriptionCouponController);